(function () {
  'use strict';

  function toggleHidden(element, shouldHide) {
    if (!element) return;
    element.hidden = shouldHide;
  }

  document.addEventListener('click', function (event) {
    var menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      var mobileNav = document.querySelector('[data-mobile-nav]');
      var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      toggleHidden(mobileNav, isOpen);
    }

    var searchToggle = event.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var searchPanel = document.querySelector('[data-search-panel]');
      var isHidden = searchPanel.hasAttribute('hidden');
      toggleHidden(searchPanel, !isHidden);
      if (isHidden) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) window.setTimeout(function () { input.focus(); }, 50);
      }
    }

    var galleryThumb = event.target.closest('[data-gallery-thumb]');
    if (galleryThumb) {
      var mainImage = document.querySelector('[data-product-gallery-main] img');
      if (mainImage) {
        mainImage.src = galleryThumb.getAttribute('data-gallery-thumb');
        mainImage.removeAttribute('srcset');
      }
      document.querySelectorAll('.gallery-thumb').forEach(function (thumb) { thumb.classList.remove('is-active'); });
      galleryThumb.classList.add('is-active');
    }

    var minus = event.target.closest('[data-quantity-minus]');
    var plus = event.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      var quantityInput = (minus || plus).parentElement.querySelector('input[type="number"]');
      if (!quantityInput) return;
      var current = parseInt(quantityInput.value || '1', 10);
      quantityInput.value = String(Math.max(1, current + (plus ? 1 : -1)));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) { count.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.quick-add-form, #ProductForm');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]:not([name="checkout"]), .quick-add');
    if (!button || button.disabled) return;
    var label = button.querySelector('[data-add-label]');
    var spinner = button.querySelector('[data-add-spinner]');
    var originalLabel = label ? label.textContent : button.textContent;
    button.disabled = true;
    if (label) label.textContent = 'Adding…'; else button.textContent = 'Adding…';
    if (spinner) spinner.hidden = false;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      })
      .then(function () {
        refreshCartCount();
        if (label) label.textContent = 'Added to bag'; else button.textContent = 'Added to bag';
        window.setTimeout(function () { if (label) label.textContent = originalLabel; else button.textContent = originalLabel; button.disabled = false; if (spinner) spinner.hidden = true; }, 1600);
      })
      .catch(function () {
        if (label) label.textContent = 'Try again'; else button.textContent = 'Try again';
        button.disabled = false;
        if (spinner) spinner.hidden = true;
      });
  });
})();
